module.exports = __webpack_public_path__ + "static/视觉EMC证书-5929c928aa141222e823350922c1e32d.jpg";